import { useState } from "react";
import "../../App.css";
import "./DeleteAccount.css";
// @ts-ignore
import logo from "../../assets/pcm.jpeg";
import { Button } from "reactstrap";
import Api from "../api/api";
import showToast from "../util/toast";

const DeleteAccount = (): JSX.Element => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isAccepted, setIsAccepted] = useState(false);

  const [warning, setWarning] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const onClick = () => {
    // Validate fields
    if (!validate(email)) return setWarning("Email can't be empty");
    if (!validate(password)) return setWarning("Password can't be empty");
    if (!isAccepted) return setWarning("Checkbox must be checked");

    setLoading(true);

    Api.deleteAccount({
      params: {
        email: email.trim(),
        password: password.trim(),
      },
      onSuccess: (response) => {
        if (response.status === "error") {
          showToast("error", response?.msg || "An error occurred");
        } else {
          showToast("success", "Account deleted");
          setEmail("");
          setPassword("");
        }
        setLoading(false);
      },
      onError: (err) => {
        showToast("error", err?.msg || "An error occurred");
        setLoading(false);
      },
    });
  };

  return (
    <div className="app page-container">
      <div className="form-container">
        <img src={logo} alt="" className="logo" />
        <div className="inputs-container">
          <input
            className="input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            className="input"
            placeholder="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div style={{ display: "flex", flexDirection: "row", gap: 6 }}>
            <input
              id="checkbox"
              checked={isAccepted}
              type="checkbox"
              title=""
              onChange={(e) => {
                setIsAccepted(e.target.checked);
              }}
            />
            <label htmlFor="checkbox">I accept this action can't be reversed</label>
          </div>
        </div>
        <div className="bottom-container">
          {warning.length > 0 && <p className="warning-text">{warning}</p>}
          <Button
            disabled={loading}
            style={{ width: 300, maxWidth: "80vw", backgroundColor: loading ? "gray" : "#b60c0c" }}
            onClick={onClick}
          >
            Delete My Account
          </Button>
        </div>
        <p className="bottom-text" >PostureCoreAndMore</p>
      </div>
    </div>
  );
};

const validate = (text: string) => text.trim().length !== 0;

export default DeleteAccount;
